import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  GetAllCountOrders,
  GetOrders,
} from '../../redux/admin/admin_order/admin_order_services_sync';
import { TableLoader } from '../../component/loader/Table_Loader';
import EmptyComponent from '../../component/EmptyComponent';
import moment from 'moment';
import {
  updateCurrentRoom,
  updateSelectedRoom,
} from '../../redux/admin/admin_room/roomSlice';
import { NavLink, useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/context';
import CurrencyFormatter, {
  NumberFormatteredWithoutSymbols,
} from '../../component/CurrencyFormatter';
import { GetAllProductCount } from '../../redux/admin/product/product_services_syn';
import { GetAllBlogCount } from '../../redux/admin/bloggers/bloggersServicesSync';
import { GetTotalUserCount } from '../../redux/admin/customer/customer_services_sync';
import LoaderScreen from '../../component/loader/loaderScreen';

const Home = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { socket } = useContext(AppContext);

  const { profile } = useSelector((state) => state.profile);

  const { my_order, my_order_loader, allCountOrder } = useSelector(
    (state) => state.admin_order
  );

  const { current_room } = useSelector((state) => state.admin_room);

  const { all_product_count } = useSelector((state) => state.product);

  const { all_blog_count } = useSelector((state) => state.blogger);

  const { totalCustomer } = useSelector((state) => state.customers);

  useEffect(() => {
    dispatch(GetAllCountOrders());

    dispatch(GetAllProductCount());

    dispatch(GetAllBlogCount());

    dispatch(GetTotalUserCount());

    dispatch(
      GetOrders({
        status: 'all',
        page: 0,
        limit: 10,
      })
    );
  }, []);

  const JoinRoom = async (room, currentRoom, isPublic = true) => {
    if (!profile) {
      return alert('please login');
    }

    await navigate('/admin_dashboard/chat');

    socket.emit('admin-join-room', room.room, currentRoom, room);

    dispatch(updateCurrentRoom(room.room));

    dispatch(updateSelectedRoom(room));
  };

  return (
    <>
      {my_order_loader && <LoaderScreen />}

      {!my_order_loader && (
        <>
          <div class="row">
            <div class="col-xxl-12">
              <div class="row">
                <div class="col-md-6">
                  <div class="card overflow-hidden">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-6">
                          <div class="avatar-md bg-soft-primary rounded">
                            <iconify-icon
                              icon="solar:cart-5-bold-duotone"
                              class="avatar-title fs-32 text-primary"
                            ></iconify-icon>
                          </div>
                        </div>
                        <div class="col-6 text-end">
                          <p class="text-muted mb-0 text-truncate">
                            Total Orders
                          </p>
                          <h3 class="text-dark mt-1 mb-0">
                            <NumberFormatteredWithoutSymbols
                              value={allCountOrder}
                              decimal={0}
                            />
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer py-2 bg-light bg-opacity-50">
                      <div class="d-flex align-items-center justify-content-between">
                        {/* <div>
                          <span class="text-success">
                            {' '}
                            <i class="bx bxs-up-arrow fs-12"></i> 2.3%
                          </span>
                          <span class="text-muted ms-1 fs-12">Last Week</span>
                        </div> */}
                        <a href="#!" class="text-reset fw-semibold fs-12">
                          View More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="card overflow-hidden">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-6">
                          <div class="avatar-md bg-soft-primary rounded">
                            <i class="bx bx-award avatar-title fs-24 text-primary"></i>
                          </div>
                        </div>
                        <div class="col-6 text-end">
                          <p class="text-muted mb-0 text-truncate">
                            Total Product
                          </p>
                          <h3 class="text-dark mt-1 mb-0">
                            <NumberFormatteredWithoutSymbols
                              value={all_product_count}
                              decimal={0}
                            />
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer py-2 bg-light bg-opacity-50">
                      <div class="d-flex align-items-center justify-content-between">
                        {/* <div>
                          <span class="text-success">
                            {' '}
                            <i class="bx bxs-up-arrow fs-12"></i> 8.1%
                          </span>
                          <span class="text-muted ms-1 fs-12">Last Month</span>
                        </div> */}
                        <a href="#!" class="text-reset fw-semibold fs-12">
                          View More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card overflow-hidden">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-6">
                          <div class="avatar-md bg-soft-primary rounded">
                            <i class="bx bxs-backpack avatar-title fs-24 text-primary"></i>
                          </div>
                        </div>
                        <div class="col-6 text-end">
                          <p class="text-muted mb-0 text-truncate">Blogs</p>
                          <h3 class="text-dark mt-1 mb-0">
                            <NumberFormatteredWithoutSymbols
                              value={all_blog_count}
                              decimal={0}
                            />
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer py-2 bg-light bg-opacity-50">
                      <div class="d-flex align-items-center justify-content-between">
                        {/* <div>
                          <span class="text-danger">
                            {' '}
                            <i class="bx bxs-down-arrow fs-12"></i> 0.3%
                          </span>
                          <span class="text-muted ms-1 fs-12">Last Month</span>
                        </div> */}
                        <a href="#!" class="text-reset fw-semibold fs-12">
                          View More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card overflow-hidden">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-6">
                          <div class="avatar-md bg-soft-primary rounded">
                            <i class="bx bx-dollar-circle avatar-title text-primary fs-24"></i>
                          </div>
                        </div>
                        <div class="col-6 text-end">
                          <p class="text-muted mb-0 text-truncate">Customers</p>
                          <h3 class="text-dark mt-1 mb-0">
                            <NumberFormatteredWithoutSymbols
                              value={totalCustomer}
                              decimal={0}
                            />
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div class="card-footer py-2 bg-light bg-opacity-50">
                      <div class="d-flex align-items-center justify-content-between">
                        {/* <div>
                          <span class="text-danger">
                            {' '}
                            <i class="bx bxs-down-arrow fs-12"></i> 10.6%
                          </span>
                          <span class="text-muted ms-1 fs-12">Last Month</span>
                        </div> */}
                        <a href="#!" class="text-reset fw-semibold fs-12">
                          View More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center justify-content-between">
                    <h4 class="card-title">Recent Orders</h4>
                  </div>
                </div>

                {my_order_loader ? (
                  <TableLoader
                    headerArray={[
                      'Order ID',
                      'Created at',
                      'Product',
                      'Customer Name',
                      'Email ID',
                      'Phone No.',
                      'Address',
                      'Status',
                      'Action',
                    ]}
                    itemArray={[1, 2, 3, 4, 5, 6, 7, 8, 9]}
                  />
                ) : (
                  <div class="table-responsive table-centered">
                    <table class="table mb-0">
                      <thead class="bg-light bg-opacity-50">
                        <tr className="py-6">
                          <th class="ps-3">Order ID.</th>
                          <th>Created at</th>
                          <th>Product</th>
                          <th>Customer Name</th>
                          <th>Email ID</th>
                          <th>Phone No.</th>
                          <th>Address</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {my_order?.docs?.length <= 0 ? (
                          <EmptyComponent />
                        ) : (
                          my_order?.docs?.map((item, key) => (
                            <tr className="py-6" key={key}>
                              <td class="ps-3">
                                <a>#{item?._id?.slice(0, 10)}...</a>
                              </td>
                              <td>
                                {moment(item?.createdAt).format('MMM, DD YYYY')}
                              </td>
                              <td>
                                <img
                                  src={
                                    `${item?.products[0]?.gallery[0]?.pic_url}` ||
                                    '/assets/images/product/p-1.png'
                                  }
                                  alt="product-1(1)"
                                  class="img-fluid avatar-sm"
                                />
                              </td>
                              <td>
                                <a href="#!">{item?.name}</a>
                              </td>
                              <td>{item?.email}</td>
                              <td>{item?.phone_number}</td>
                              <td>{item?.address_one}</td>

                              <td>
                                <i
                                  class={`bx bxs-circle ${
                                    item?.status === 'pending'
                                      ? 'text-secondary'
                                      : item?.status === 'processing'
                                      ? 'text-warning'
                                      : item?.status === 'cancelled'
                                      ? 'text-danger'
                                      : 'text-success'
                                  }  me-1`}
                                ></i>
                                {item?.status}
                              </td>

                              <td>
                                <div class="d-flex gap-2">
                                  <NavLink
                                    to={`/admin_dashboard/view_order/${item?.name}@${item?._id}`}
                                  >
                                    <a class="btn btn-light btn-sm">
                                      <iconify-icon
                                        icon="solar:eye-broken"
                                        class="align-middle fs-18"
                                      ></iconify-icon>
                                    </a>
                                  </NavLink>

                                  <a
                                    onClick={() => {
                                      const payload = {
                                        ...item,
                                        room: `${item?._id}-${item?.createdBy}-admin`,
                                      };

                                      JoinRoom(payload, current_room);
                                    }}
                                    class="btn btn-light btn-sm"
                                  >
                                    <iconify-icon
                                      icon="solar:chat-round-bold-duotone"
                                      class="align-middle fs-18"
                                    ></iconify-icon>
                                  </a>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}

                <div class="card-footer border-top">
                  <div class="row g-3">
                    <div class="col-sm"></div>

                    <div class="col-sm-auto"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Home;
